// src/views/app-views/acquisition/index.js
import { Route, Routes } from "react-router-dom";
import ProtectedRoute from "../../../components/util-components/ProtectedRoute";
import React from "react";
import Leads from "./leads";
import Shipments from "./shipments";

const Acquisition = () => {
  return (
    <Routes>
      <Route
        path={`/leads`}
        element={
          <ProtectedRoute routeKey={"leads"}>
            <Leads />
          </ProtectedRoute>
        }
      />
      <Route
        path={`/shipments`}
        element={
          <ProtectedRoute routeKey={"shipments"}>
            <Shipments />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
};

export default Acquisition;
